import script from "./AchievementCard.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementCard.vue?vue&type=script&setup=true&lang=js"

import "./AchievementCard.vue?vue&type=style&index=0&id=d6353074&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6353074"]])

export default __exports__